function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import Splitting from "splitting";
import { sendDataLayerMoreEvent } from './utils';
var HeadlineComponent = function HeadlineComponent(_ref) {
  var data = _ref.data,
    classVariation = _ref.classVariation,
    mobileFlag = _ref.mobileFlag;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    exitClass = _useState2[0],
    setExitClass = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    wideClass = _useState4[0],
    setwideClass = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    currHeadline = _useState6[0],
    setHeadline = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    splittedHeadline = _useState8[0],
    setsplittedHeadline = _useState8[1];
  useEffect(function () {
    if (data.html) {
      var isNewValues = currHeadline && currHeadline.html.html != data.html.html;
      var customWideClass = data.html.html && data.html.html.length > 480 ? 'auto-wider' : '';
      setwideClass(customWideClass);
      if (isNewValues) {
        setExitClass('exit');
        if (mobileFlag) {
          setHeadline(null);
        }
      } else {
        setExitClass('');
      }
      var timer = setTimeout(function () {
        setExitClass('');
      }, 220);
      setHeadline(data);
      return function () {
        return clearTimeout(timer);
      };
    }
  }, [data]);
  useEffect(function () {
    var timer = setTimeout(function () {
      var headline = mobileFlag ? currHeadline.html.html : Splitting.html({
        content: currHeadline.html.html,
        by: 'chars'
      });
      setsplittedHeadline(headline);
    }, 120);
    return function () {
      return clearTimeout(timer);
    };
  }, [currHeadline]);
  useEffect(function () {
    window.DGS.Event.getInstance().trigger('link-embed-code-detected');
  }, [splittedHeadline]);
  var clickHandler = function clickHandler(e) {
    var element = e.currentTarget;
    var currentClass = !mobileFlag && window.location.href.split('?')[1] ? window.location.href.split('?')[1] : '';
    if (element.classList.contains('has-video')) {
      sendDataLayerMoreEvent('All link & Button Clicks', 'Watch film', 'layer clicked');
    } else if (element.getAttribute('href')) {
      sendDataLayerMoreEvent('All link & Button Clicks', 'Discover', currentClass + ' > ' + element.getAttribute('href'));
    }
  };
  var headlinesElement = function headlinesElement($element) {
    try {
      if ($element && !$element.classList.contains('event-initialized')) {
        $element.classList.add('event-initialized');
        $element.querySelectorAll('a:not(.event-initialized)').forEach(function ($el, index) {
          $el.classList.add('event-initialized');
          $el.addEventListener('click', function (e) {
            return clickHandler(e);
          });
        });
      }
    } catch (e) {
      console.log(e);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, currHeadline && splittedHeadline && /*#__PURE__*/React.createElement("div", {
    className: classVariation + " section-text__headlines " + exitClass + ' ' + wideClass,
    dangerouslySetInnerHTML: {
      __html: splittedHeadline
    },
    ref: headlinesElement
  }));
};
export default HeadlineComponent;